<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogUpload',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-member-upload-dialog'" title="人员导入" width="800px"
    @ok="onConfirmUpload" @cancel="closeDialog" :closable="false" :maskClosable="false">
    <div style="display: flex; justify-content: space-between; padding: 20px 0">
      <div style="width: 48%; text-align: center; padding: 30px; background: #f5f5f5; border-radius: 4px">
        <div style="font-size: 16px; margin-bottom: 20px">数据模板</div>
        <a-button type="primary" @click="onDownloadTemplate">
          <DownloadOutlined />下载模板
        </a-button>
        <div style="margin-top: 10px; color: #999; font-size: 12px">请根据模板要求进行填写</div>
      </div>
      <div style="width: 48%; text-align: center; padding: 30px; background: #f5f5f5; border-radius: 4px">
        <div style="font-size: 16px; margin-bottom: 20px">导入文件</div>
        <a-upload ref="uploadRef" :action="uploadUrl" :headers="headers"
          :data="{ biz: 'import_staff_src', saveFlag: '1' }" :limit="1" :before-upload="beforeUpload"
          @change="handleChange">
          <a-button type="success">
            <UploadOutlined />上传文件
          </a-button>
        </a-upload>
        <div style="margin-top: 10px; color: #999; font-size: 12px">文件大小不要超过5MB</div>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogUpload">
import { reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons-vue'
import ls from '@/utils/Storage'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const emit = defineEmits(['uploadSuccess'])

const uploadRef = ref()
const baseURL = import.meta.env.VITE_PROXY
const uploadUrl = baseURL + '/console/staff/importData'

const headers = {
  token: ls.get(ACCESS_TOKEN) || ''
}

const state = reactive({
  dialog: {
    visible: false
  },
  loading: false
})

const openDialog = () => {
  state.dialog.visible = true
}

const closeDialog = () => {
  state.dialog.visible = false
  uploadRef.value?.clearFiles?.()
}

const onDownloadTemplate = () => {
  window.location.href = '/站员导入模板.xlsx'
}

const beforeUpload = (file: any) => {
  if (!file.name.endsWith('.xlsx')) {
    message.error('请上传文件为xlsx格式')
    return false
  }
  if (file.size / 1024 / 1024 > 5) {
    message.error('文件不能超过5MB!')
    return false
  }
  return true
}

const handleChange = (info: any) => {
  if (info.file.status === 'done') {
    const res = info.file.response
    if (res.code === 200 || !res.code) {
      emit('uploadSuccess', res.data)
      closeDialog()
    } else {
      message.error(res.msg || res.message || '上传失败')
    }
  } else if (info.file.status === 'error') {
    message.error('上传失败')
  }
}

const onConfirmUpload = () => {
  uploadRef.value?.uploadFiles?.forEach?.((file: any) => {
    if (file.status !== 'done') {
      message.warning('请先上传文件')
    }
  })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>
